exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animation-container[data-v-7f9e66b6] {\n  margin-top: -165px;\n  margin-bottom: -120px;\n}\n@media only screen and (max-width: 769px) {\n.animation-container[data-v-7f9e66b6] {\n    margin-top: -50px;\n    margin-bottom: 0;\n}\n}", ""]);

// exports
